import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { Font14, Font16 } from 'components/Typography'

export const SubsManageRightPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 24px 24px 24px;
  background-color: ${theme.colors.white};
  box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.01);
  border-radius: 8px;
  transition: all 0.2s ease;
  margin-bottom: 40px;
  @media ${theme.devices.tabletLandscape} {
    margin-bottom: 0;
    width: 35%;
  }
`

export const ActivePlanLabel = styled.div`
  ${Font16};
  text-transform: capitalize;
  color: ${theme.colors.moreGrey};
`

export const RightPanelPlanWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0;
  transition: all 0.2s ease;
`

export const NextBillingDateWrapper = styled(RightPanelPlanWrapper)`
  padding: 16px 0 0 0;
`

export const CurrentlyPayingWrapper = styled(RightPanelPlanWrapper)`
  padding: 8px 0 24px 0;
`

export const ActivePlanIcon = styled(Icon)`
  color: ${theme.colors.successGreen};
`

export const PlanNameLabel = styled.div`
  text-transform: capitalize;
  ${Font16};
  font-weight: 900;
  line-height: 24px;
`

export const PlanPriceLabel = styled.div`
  ${Font16};
  line-height: 24px;
`

export const NextBillingDateLabel = styled.div`
  ${Font14};
`

export const RightPanelBlock = styled.div`
  display: flex;
`

export const RightPanelBottomLine = styled.div`
  border-bottom: 1px solid ${theme.colors.lightGrey};
  width: 100%;
`

export const RightPanelBottomText = styled.div`
  padding: 16px 0;
  ${Font14};
  line-height: 18px;
  color: ${theme.colors.darkeyGrey};
`

export const UpgradePlanLabel = styled.div`
  text-transform: capitalize;
  font-weight: 900;
  font-size: 20px;
  line-height: 24px;
  color: ${theme.colors.horizonOrange};
`

export const UpgradePlanIcon = styled(Icon)`
  color: ${theme.colors.duneWarmGrey};
`

export const TotalToPayLabel = styled.div`
  font-weight: 900;
  font-size: 18px;
  line-height: 24px;
`

export const TotalToPayPriceLabel = styled.div`
  font-weight: 900;
  font-size: 18px;
  line-height: 24px;
  color: ${theme.colors.horizonOrange};
`
export const BilledAnnualWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`
export const BilledAnnualLabel = styled.div`
  margin-bottom: 15px;
  background: ${theme.colors.hover10};
  border-radius: 8px;
  order: 0;
  padding: 8px;
  ${Font16};
  color: ${theme.colors.otterWarmBlack};
`
